/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ShowDeletedCheckbox/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Checkbox from 'DesignSystem/Checkbox/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ShowDeletedCheckbox({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/Comparison/Content/Content/Actions/Choose/ImageSelect/Content/Content/ShowDeletedCheckbox",
  onChange
  
}) {
let imagesComparisonActionShowDeletedImageSeriesValueData = fromData.useDataValue({ viewPath,
context: 'images_comparison_action',
path: 'show_deleted_image_series',
})
let imagesComparisonActionShowDeletedImageSeriesChangeData = fromData.useDataChange({ viewPath,
context: 'images_comparison_action',
path: 'show_deleted_image_series',
})
  return (<React.Fragment
>
<Checkbox
  viewPath={`${viewPath}/Checkbox`}
 data="images_comparison_action.show_deleted_image_series"
 isSelected={imagesComparisonActionShowDeletedImageSeriesValueData}
 onClick={imagesComparisonActionShowDeletedImageSeriesChangeData}
 marginLeft={8}
 text="Show deleted image series"
/>
{children}
</React.Fragment>)
}